import { Localized } from "@fluent/react";
import { LinearProgress } from "@mui/material";
import { useEffect } from "react";
//import { getAlarmGroups, removeAlarmGroupUser } from "../../store/thunk/alarmGroup";
import { getOrganizationUsers } from "../../store/thunk/organizationUser";
import { useAppDispatch, useAppSelector } from "../../store/hooks";
import { RejectionReason } from "../../store/slices/alarmGroup";
import OrganizationUserList from "../ui/OrganizationUserList";

export default function OrganizationUsers() {
	const dispatch = useAppDispatch();
	const organizationUser = useAppSelector(state => state.organizationUsers);

	useEffect(() => {
		// If we don't have data yet and not attempt was made to request it,
		// dispatch a request to get the data of the users within the organization in the state.
		if (organizationUser.kind === "initializing"
			&& !organizationUser.pending && organizationUser.rejectionReason === undefined) {
			dispatch(getOrganizationUsers());
		}
	}, [dispatch, organizationUser]);

	switch (organizationUser.kind) {
		case 'initializing':
			if (organizationUser.rejectionReason !== undefined) {
				switch (organizationUser.rejectionReason) {
					case RejectionReason.Network:
						return <Localized id="loading-failed-network" />;
					case RejectionReason.Bug:
						return <Localized id="loading-failed-bug" />;
				}
			}

			return <LinearProgress sx={{ height: "8px" }} />;
		case 'ready':
			return <>
				<OrganizationUserList 
					users={organizationUser.organizationUsers}/>
			</>;
	}
}
